import { render, staticRenderFns } from "./SafetyDays.vue?vue&type=template&id=793c44e1&scoped=true&"
import script from "./SafetyDays.vue?vue&type=script&lang=js&"
export * from "./SafetyDays.vue?vue&type=script&lang=js&"
import style0 from "./SafetyDays.vue?vue&type=style&index=0&id=793c44e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793c44e1",
  null
  
)

export default component.exports